(ns frontend.view.grid.oppos-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce deals (r/cursor app-db/views [:oppos-grid]))
(defonce modal-state (r/cursor deals [:modals]))
(defonce grid-entities (r/cursor deals [:grid-entities]))
(defonce view-settings (r/cursor deals [:view-settings]))
(defonce deal-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor deals [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor deals [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor deals [:schema]))

(defonce server-time (r/cursor app-db/session [:server-time]))
